import { Route, Routes, useLocation } from 'react-router-dom';
import { DrawListPage } from './DrawListPage';
import { DrawDetailPage } from './DrawDetailPage';
import { useContextNavigate } from '../../hooks/navigate';
import { useEffect } from 'react';
import { AppContext } from '../../components/Menu/MenuButton';
import { DrawMethod } from './DrawItem';
import { DrawWinnersPage } from '../DrawWinnersPage/DrawWinnersPage';

export enum DrawContext {
    Detail = 'detail',
    Automatic = 'automatic',
    Interactive = 'interactive',
    Winners = 'winners',
}

export const DrawRoutes = () => {
    const navigate = useContextNavigate<DrawContext>();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === `/${AppContext.Draw}`) {
            navigate(DrawContext.Interactive, { replace: true, state: location.state });
        }
    }, [location.pathname, location.state, navigate]);
    
    return (
        <Routes>
            <Route path={ `/${DrawContext.Interactive}/:drawId?` } element={<DrawListPage method={ DrawMethod.Interactive } />} />
            <Route path={ `/${DrawContext.Automatic}/:drawId?` } element={<DrawListPage method={ DrawMethod.Automatic } />} />
            <Route path={ `/${DrawContext.Detail}/:drawId` } element={<DrawDetailPage />} />
            <Route path={ `/${DrawContext.Winners}` } element={<DrawWinnersPage />} />
        </Routes>
    );
};